import { render, staticRenderFns } from "./DonorAcceptor.vue?vue&type=template&id=3c381898&scoped=true&"
import script from "./DonorAcceptor.vue?vue&type=script&lang=js&"
export * from "./DonorAcceptor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c381898",
  null
  
)

export default component.exports